<ul role="listbox"
  [attr.aria-label]="listLabel"
  [title]="listLabel">
  <!-- CAPSULE LIST -->
  <li #itemObject
    *ngFor="let item of items; index as i; trackBy: trackByIndex"
    [attr.disabled]="disabled ? '' : null"
    [id]="getCapsuleId(item)"
    [title]="getItemName(item)"
    class="item capsule"
    [attr.tabindex]="activeContainer ? -1 : 0"
    [ngClass]="{
      selected: getIsItemSelected(item),
      editable: isItemEditable(item),
      timeline: timeline,
      custom: hasCustomClass(item),
      selectable: enableSelection,
    }"
    (appAccessibleClick)="selectItem(item)"
    appAccessibilityAnnouncer
    listenedEvent="enter"
    [announceText]="getAnnounceText(item)"
    role="option"
    [attr.aria-selected]="getIsItemSelected(item)"
    [attr.aria-label]="getItemName(item)">
    <!-- Remove Icon -->
    <i [attr.dir]="dir"
      class="i-vi-delete"
      *ngIf="isItemEditable(item)"
      role="button"
      (appAccessibleClick)="removeItem(item, $event)"
      appAccessibilityTooltip
      [showAccessibilityTooltip]="!activeContainer && accessibilityMode"
      [attr.title]="resources?.KeywordRemoveTitle"
      [attr.tabindex]="activeContainer ? -1 : 0"
      [attr.aria-hidden]="activeContainer ? 'true':'false'"
      [attr.aria-label]="resources?.KeywordRemoveTitle"></i>

    <span [attr.title]="getItemName(item)"
      class="item-text"
      [innerHTML]="getItemName(item)"></span>

    <!-- Legacy injected input slot (kept for backward compatibility) -->
    <ng-container class="injected-input"
      *ngTemplateOutlet="injectedInputTemplate; context: { $implicit: item }">
    </ng-container>
  </li>

  <!-- ADD CAPSULE SLOT -->
  <div class="add-capsule-container"
    *ngIf="edit && enableAddNewItem"
    role="none">
    <!-- If consumer provided custom add template, render it -->
    <ng-container *ngIf="customAddTemplate; else defaultAddTemplate"
      [ngTemplateOutlet]="customAddTemplate">
    </ng-container>
    <!-- Default template intentionally empty to avoid coupling to insights capsule-input -->
    <ng-template #defaultAddTemplate>
      <app-vi-insights-capsule-input [text]="placeholderText"
        [EnterText]="placeholderEnterText"
        [items]="items"
        (addCapsule)="handleAddCapsule($event)"
        [activeContainer]="activeContainer">
      </app-vi-insights-capsule-input>
    </ng-template>
  </div>

  <!-- OVERFLOW PLACEHOLDER -->
  <li class="item overflow"
    role="button"
    *ngIf="conf?.overflowValue && !conf?.expanded"
    [attr.tabindex]="activeContainer ? -1 : 0"
    (mouseup)="toggleExpandMouse($event)"
    (keyup.enter)="toggleExpand(true)"
    [attr.title]="resources?.ShowMore"
    [ngStyle]="{'width.px': conf?.overflowWidth}">
    <div class="circle">
      {{ conf?.overflowSentence ? conf?.overflowSentence : ('+' + conf?.overflowValue) }}
    </div>
  </li>
</ul>
